import { Icon } from "@zambezi/sdk/icons"
import React, { FC } from "react"
import { Tagline } from "../../../Elements/Tagline"
import { Column, Columns } from "../../Columns"
import { FooterLayoutProps } from "../Footer.types"
import Copyright from "../Segments/Copyright"
import FooterLinks from "../Segments/FooterLinks"

const Full: FC<FooterLayoutProps> = ({
    links,
    ...props
}: FooterLayoutProps) => {
    return (
        <div {...props}>
            <Columns mobile={true}>
                <Column
                    size={4}
                    viewports={{
                        tablet: 4,
                        mobile: 4,
                    }}
                >
                    <Tagline />
                </Column>
                <Column
                    size={5}
                    offset={3}
                    viewports={{
                        tablet: { size: 5, offset: 3 },
                        mobile: { size: 6, offset: 2 },
                    }}
                >
                    <div className="zb-flex zb-flex-end zb-flex-row-vcentered zb-footer-cta">
                        <div className="zb-flex-none">
                            <Icon
                                name="call-us"
                                title=""
                                style={{ color: "white" }}
                            />
                        </div>
                        <div className="zb-flex-none">
                            Call us
                            <br className="zb-is-visible-mobile-inline" />
                            <span className="zb-is-hidden-mobile"> </span>
                            0345 302 0190
                        </div>
                    </div>
                </Column>
            </Columns>
            <Columns reversed={"mobile"}>
                <Column
                    size={7}
                    viewports={{
                        tablet: 6,
                        mobile: 12,
                    }}
                >
                    <span className="zb-footer-text">
                        <Copyright />
                    </span>
                </Column>
                <Column
                    size={5}
                    className={"zb-text-right"}
                    viewports={{
                        tablet: 6,
                        mobile: 12,
                    }}
                    style={{ fontSize: 16 }}
                >
                    <span className="zb-footer-text zb-text-right zb-text-center-mobile">
                        <FooterLinks links={links} />
                    </span>
                </Column>
            </Columns>
        </div>
    )
}

export default Full
